/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineProductService() {
        let productService = {};
        productService.getProducts = function (request){
            return axios.post("/api/ProductService/GetProducts", request);
        };
        productService.getProduct = function (productId){
            return axios.get("/api/ProductService/GetProduct?productId=" + productId);
        };
        productService.addOrUpdateProduct = function (request){
            return axios.post("/api/ProductService/AddOrUpdateProduct", request);
        };
        productService.extractDeliveryZonalPricing = function (request){
            return axios.post("/api/ProductService/ExtractDeliveryZonalPricing", request, { headers: {'Content-Type': 'multipart/form-data' }});
        };
        productService.generateProductCode = function (request){
            return axios.post("/api/ProductService/GenerateProductCode", request);
        };
        productService.markProductAsActiveOrInactive = function (request){
            return axios.post("/api/ProductService/MarkProductAsActiveOrInactive", request);
        };
        productService.getZoneProductBasePrices = function (request){
            return axios.post("/api/ProductService/GetZoneProductBasePrices", request);
        };
        productService.getZoneProductBasePrice = function (zoneProductBasePriceId){
            return axios.get("/api/ProductService/GetZoneProductBasePrice?zoneProductBasePriceId=" + zoneProductBasePriceId);
        };
        productService.addOrUpdateZoneProductBasePrice = function (request){
            return axios.post("/api/ProductService/AddOrUpdateZoneProductBasePrice", request);
        };
        productService.markZoneProductBasePriceAsActiveOrInactive = function (request){
            return axios.post("/api/ProductService/MarkZoneProductBasePriceAsActiveOrInactive", request);
        };
        productService.getZoneProductBasePricesByProduct = function (productId, orderTypeId){
            return axios.get("/api/ProductService/GetZoneProductBasePricesByProduct?productId=" + productId + "&orderTypeId=" + orderTypeId);
        };
        productService.zoneProductBasePriceBulkImport = function (request){
            return axios.post("/api/ProductService/ZoneProductBasePriceBulkImport", request);
        };
        productService.validateZoneProductBasePriceBulkImport = function (request){
            return axios.post("/api/ProductService/ValidateZoneProductBasePriceBulkImport", request);
        };
        productService.getCompanyShippingAddressPrices = function (request){
            return axios.post("/api/ProductService/GetCompanyShippingAddressPrices", request);
        };
        productService.addOrUpdateCompanyShippingAddressPrice = function (request){
            return axios.post("/api/ProductService/AddOrUpdateCompanyShippingAddressPrice", request);
        };
        productService.markCompanyShippingAddressPriceAsActiveOrInactive = function (request){
            return axios.post("/api/ProductService/MarkCompanyShippingAddressPriceAsActiveOrInactive", request);
        };
        productService.getLatestZoneProductBasePrice = function (request){
            return axios.post("/api/ProductService/GetLatestZoneProductBasePrice", request);
        };
        productService.getZoneProductBasePricesWithShippingAddresses = function (request){
            return axios.post("/api/ProductService/GetZoneProductBasePricesWithShippingAddresses", request);
        };
        productService.getCompanyProductTypes = function (companyId){
            return axios.get("/api/ProductService/GetCompanyProductTypes?companyId=" + companyId);
        };
        productService.getProductTypes = function (){
            return axios.get("/api/ProductService/GetProductTypes");
        };
        productService.getCompanyShippingAddressPricesForShippingAddress = function (request){
            return axios.post("/api/ProductService/GetCompanyShippingAddressPricesForShippingAddress", request);
        };
        productService.getProductsByCustomerProductType = function (request){
            return axios.post("/api/ProductService/GetProductsByCustomerProductType", request);
        };
        return productService;
    }
    //define globally if it doesn't already exist
    if (typeof (productService) === "undefined") {
        window.productService = defineProductService();
    } else {
        console.log("productService already defined.");
    }
})(window);